import { lazyLoad } from 'utils/loadable';

export const LocalizationManagement = lazyLoad(
  () => import('./index'),
  module => module.LocalizationManagement,
);
